import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'mf-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class Footer implements OnInit {
    ngOnInit(): void {
        
    }
}